export function fenToYuan(fen) {
	return (Number(fen || 0) / 100).toFixed(2)
}

export function yuanToFen(yuan) {
	return Math.round(parseFloat(yuan) * 100)
}

export function apiMsg(res, fallback) {
	return (res && res.data && (res.data.msg || res.data.message)) || fallback || '操作失败'
}

export function formatEntryDiscount(val) {
	var num = Number(val)
	if (isNaN(num)) {
		return '--'
	}
	if (num > 10) {
		return (num / 100).toFixed(2)
	}
	return String(num)
}

export function stockDiscountZhe(val) {
	var num = Number(val)
	if (isNaN(num)) {
		return NaN
	}
	if (num > 10) {
		return num / 100
	}
	return num
}



// WEBPACK FOOTER //
// ./src/components/seller/warehouse/money.js